import { signOut } from 'aws-amplify/auth';
import { getAuthTokenOrLogOut } from '../util';
import { startChat } from './chat-jq';

export interface StartChatSessionRequest {
  message: string;
  mpxn: string;
  chatReason: string;
}

export type StartChatSessionOutcome = 'STARTED' | 'SESSION_EXPIRED';

/**
 * Single entry point for opening an SST chat from any journey.
 *
 * Fetches the engineer's Cognito details and hands them to `startChat`. `getAuthTokenOrLogOut`
 * resolves `{ userEmail: null, token: null }` (without signing out) when the session has no
 * tokens, and `startChat` would then throw on `sessionUserEmail.split('@')`. To avoid that dead
 * button, an expired session never reaches `startChat`; the engineer is signed out instead, so the
 * Authenticator presents the login screen and they can log in again.
 *
 * Lives in its own module (not `util.ts`) on purpose: component tests rely on the global
 * `getAuthTokenOrLogOut` mock in `setupTests.ts`, which only intercepts cross-module imports.
 */
export async function startChatSession(request: StartChatSessionRequest): Promise<StartChatSessionOutcome> {
  const { userEmail, token } = await getAuthTokenOrLogOut();

  if (!userEmail || !token) {
    console.warn('Cannot start chat: the session has expired. Signing out.');
    await signOut();
    return 'SESSION_EXPIRED';
  }

  startChat(request.message, userEmail, token, request.mpxn, request.chatReason);
  return 'STARTED';
}
